export default {"src":"/_next/static/media/optimism.84d4f0ef.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};